const root = process.env.REACT_APP_API_GRAPHQL;
const mainNavbarRoute =  root + '?query={opciondemenu{rutadestino icono{urls} descripcion{html}}}';

export default mainNavbarRoute;